import { render, staticRenderFns } from "./StepTemplate.vue?vue&type=template&id=15d54e22&"
import script from "./StepTemplate.vue?vue&type=script&lang=js&"
export * from "./StepTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports